import { TemplateEnum } from '../../../utils/enum';

import styles from './html-body-landing-page.module.scss';

import HeaderFooterLandingPageFeature from '../../../feature/header-footer-landing-page-feature/header-footer-landing-page-feature';
import BdcFeature from '../../../feature/template/bdc-feature/bdc-feature';
import AmendmentFeature from '../../../feature/template/amendment-feature/amendment-feature';
import MandatGestionFeature from '../../../feature/template/mandat-gestion-feature/mandat-gestion-feature';
import DechargeNonConformiteFeature from '../../../feature/template/decharge-non-conformite-feature/decharge-non-conformite-feature';
import DechargeTravauxSansDeclarationFeature from '../../../feature/template/decharge-travaux-sans-declaration-feature/decharge-travaux-sans-declaration-feature';
import DechargeClientFeature from '../../../feature/template/decharge-client-feature/decharge-client-feature';

export interface HtmlBodyLandingPageProps {
  sign1Ref: any;
  sign2Ref: any;
  documentSlug: TemplateEnum | undefined;
}

const HtmlBodyLandingPage = (props: HtmlBodyLandingPageProps) => {
  const { sign1Ref, sign2Ref, documentSlug } = props;

  return (
    <div className={styles['LandingPage-container']}>
      <HeaderFooterLandingPageFeature
        sign1Ref={sign1Ref}
        sign2Ref={
          documentSlug &&
          [TemplateEnum.BDC, TemplateEnum.UPSELL].includes(documentSlug)
            ? sign2Ref
            : null
        }
        isBDC={TemplateEnum.BDC === documentSlug ? true : false}
      />

      {documentSlug === TemplateEnum.BDC && (
        <BdcFeature sign1Ref={sign1Ref} sign2Ref={sign2Ref} />
      )}
      {documentSlug === TemplateEnum.UPSELL && (
        <AmendmentFeature sign1Ref={sign1Ref} sign2Ref={sign2Ref} />
      )}
      {documentSlug === TemplateEnum.MANDAT_GESTION && (
        <MandatGestionFeature sign1Ref={sign1Ref} />
      )}
      {documentSlug === TemplateEnum.DECHARGE_NON_CONFORMITE && (
        <DechargeNonConformiteFeature sign1Ref={sign1Ref} />
      )}
      {documentSlug === TemplateEnum.DECHARGE_TVX_SANS_DECLARATION && (
        <DechargeTravauxSansDeclarationFeature sign1Ref={sign1Ref} />
      )}
      {documentSlug === TemplateEnum.DECHARGE_CLIENT && (
        <DechargeClientFeature sign1Ref={sign1Ref} />
      )}
    </div>
  );
};

export default HtmlBodyLandingPage;
